module.exports = __webpack_public_path__ + "img/news-section-image02.80b9dac2.png";